// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__b17Nr","main-image":"Header_main-image__3dBTY"};